import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './TemplateSelector.module.scss'
import { useSelector } from 'react-redux';
export default function TemplateSelector () {
  const templatesData = useSelector((state) => state.templates.templates);
  return (
    <div className={styles.container}>
      <h1>Choose Template</h1>
      <div className={styles.templates}>
        {templatesData.map((item, i) =>
          <NavLink
            to={`/mpublisher/template/${item.id}`}
            key={i} className={styles.template}>
            <img src={item.thumbnail} alt={i} />
          </NavLink>
        )}
      </div>
    </div>
  );
}
